import ProgressBarCIDModal from './ProgressBarCIDModal';

export default ProgressBarCIDModal;
